import React from "react";
import DialogTitle from "@mui/material/DialogTitle";

interface RollerHeaderProps {
    rolled: boolean;
}

const rollerHeader: React.FC<RollerHeaderProps> = ({ rolled }) => {
    return <DialogTitle>{rolled ? 'Gewürfelt' : 'Würfeln'}</DialogTitle>;
};

export default rollerHeader;